import Navbar from '../Miscellaneous/Navbar'
import React, { useEffect } from 'react';
import Footer from '../Miscellaneous/Footer';
import FaqsTemp from '../Miscellaneous/FaqTemp';
const FAQ = () => {
  useEffect(() => {
    document.title = "FAQ's - Roop Sweets"

    const handleScroll = () => {
      const bgElement = document.querySelector('.contactBG');
      const screenWidth = window.innerWidth;

      if (bgElement) {
        const scrollPosition = window.scrollY;

        if (screenWidth <= 500) {
          bgElement.style.backgroundPosition = `center ${scrollPosition * 0.5}px`;
        } else {
          bgElement.style.backgroundPosition = `center ${scrollPosition * -0.5}px`;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <>
      <Navbar />
      <div className='firstdivcont'>
        <FaqsTemp />
        <Footer />
      </div>
    </>
  );
};
export default FAQ;
